import Swiper from 'swiper/bundle';

export function seoCity() {
	const sliderEl = document.querySelector('.seo-city-slider-js');
	if (!sliderEl) return;
	const catalogBtnSlider = new Swiper(sliderEl, {
		speed: 600,
		spaceBetween: 15,
		loop: true,
		slidesPerView: 'auto',
		// slidesPerGroup: 1,
		slidesOffsetBefore: 10,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		slidesOffsetAfter: 0,
		mousewheel: {
			thresholdDelta: 70
		},
	});
}
